<template>
  <div class="flex flex-row items-center space-x-4" style="flex: none">
    <div class="container mx-auto p-8 max-w-3xl bg-white shadow-lg rounded-lg">
      <h1 class="text-3xl font-extrabold text-center mb-6 text-gray-800">Cookies Policy</h1>

      <p class="text-gray-700 leading-relaxed">
        In order to make your visits to our project Site as pleasant as possible, the
        <strong>CertifAI Integrated Framework</strong> uses cookies. These cookies automatically
        track and collect certain technical information that your browser sends to us. This
        information might include Internet protocol (IP) addresses, the browser type, browser
        language, Internet service providers (ISP), referring/exit pages, URLs, operating systems,
        date/time stamps, and other similar information. However, this information doesn’t identify
        individual users and we use it exclusively to analyse trends, to administer the site, to
        track user movements around the site as a whole to improve the services provided.
      </p>

      <h2 class="text-2xl font-semibold mt-8 text-gray-900 pb-2">What is a Cookie?</h2>
      <p class="text-gray-700 leading-relaxed">
        Cookies are simple text files downloaded to your computer or mobile device when you visit a
        website or page, so the website can recognize your device the next time you visit. They’re
        essential for easy navigation, making your experience faster, easier, and more personalized.
      </p>

      <h2 class="text-2xl font-semibold mt-8 text-gray-900 pb-2">Types of Cookies</h2>
      <div class="mt-4 space-y-4">
        <div>
          <h3 class="text-xl font-medium text-gray-800">Strictly Necessary Cookies</h3>
          <p class="text-gray-700 leading-relaxed">
            These cookies are essential for the operation of the site. If you disable them, you will
            not be able to access or use the website.
          </p>
        </div>
        <div>
          <h3 class="text-xl font-medium text-gray-800">Functionality Cookies</h3>
          <p class="text-gray-700 leading-relaxed">
            These cookies allow us to remember your preferences, such as language selection.
          </p>
        </div>
        <div>
          <h3 class="text-xl font-medium text-gray-800">Performance / Analytics Cookies</h3>
          <p class="text-gray-700 leading-relaxed">
            These cookies help us analyze how the website is accessed and used to enhance the user
            experience.
          </p>
        </div>
      </div>

      <h2 class="text-2xl font-semibold mt-8 text-gray-900 pb-2">
        Retention Period of Cookies
      </h2>
      <p class="text-gray-700 leading-relaxed">
        Session cookies are temporary and are not retained after closing the browser. Functionality
        and Performance/Analytics cookies may be stored for up to 2 years.
      </p>

      <h2 class="text-2xl font-semibold mt-8 text-gray-900 pb-2">
        How to Control Cookies
      </h2>
      <p class="text-gray-700 leading-relaxed">
        You can choose to accept or refuse cookies through the pop-up on this site. However,
        rejecting cookies may limit functionality.
      </p>
      <p class="text-gray-700 leading-relaxed">
        To adjust settings in your browser, visit the links below:
      </p>
      <ul class="list-disc ml-6 text-blue-500 underline space-y-2">
        <li>
          <a href="https://support.microsoft.com/en-us/products/windows?os=windows-10"
            >Internet Explorer</a
          >
        </li>
        <li>
          <a
            href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies"
            >Firefox</a
          >
        </li>
        <li><a href="https://support.google.com/chrome/answer/95647?hl=en">Chrome</a></li>
        <li><a href="https://support.google.com/chrome/answer/95647?hl=en">Safari Web</a></li>
        <li><a href="https://support.apple.com/en-us/HT201265">iOS</a></li>
      </ul>

      <h2 class="text-2xl font-semibold mt-8 text-gray-900 pb-2">
        Changes to This Policy
      </h2>
      <p class="text-gray-700 leading-relaxed">
        We may change this policy to reflect updates in legal frameworks and practices. Please check
        periodically for updates.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookiesPolicy',
};
</script>

<style scoped>
.container {
  background-color: #f9fafb;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>
